// Components
import { Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import MembershipCard from './membership-card/MembershipCard'
import MoneyBackGuarantee from '@sections/v25/ft1/money-back-guarantee/MoneyBackGuarantee'

interface MembershipWrapperProps {
  redirectURL?: string
}

const MembershipWrapper = ({ redirectURL }: MembershipWrapperProps) => {
  return (
    <Section padding={[32, 0]}>
      <Flex flexDirection="column" rowGap={{ sm: 32 }}>
        <div>
          <Text
            tagName="h2"
            variant="title-2"
            spacing={{ sm: 8 }}
            align="center"
            transform="capitalize"
          >
            Start your membership today
          </Text>

          <Text
            tagName="p"
            variant="body-1"
            align="center"
            spacing={{ sm: 32 }}
          >
            Join <b>50,000+</b> members and never pay full fare again!
          </Text>
        </div>

        <MembershipCard redirectURL={redirectURL} />

        <MoneyBackGuarantee />
      </Flex>
    </Section>
  )
}

export default MembershipWrapper
